export default function RowSelector({
  id,
  className,
  data,
  selected,
  onRowSelectionChanged,
}) {
  function handleCheckBoxCellClick(e) {
    e.stopPropagation()
    onRowSelectionChanged(data)
  }

  return (
    <div className={className} onClick={handleCheckBoxCellClick}>
      <input
        type="checkbox"
        name={`selectrow-${id}`}
        data-testid={`form-input-selectrow-${id}`}
        className="!h-4 !w-4 shrink-0 rounded border-gray-300 text-blue-600 focus:ring-blue-400/50"
        style={{ width: "16px", height: "16px" }}
        checked={selected || false}
        readOnly
      />
    </div>
  )
}
